<template>
  <div class="component-set-up">
  </div>
</template>

<script>
export default {
  name: 'setUp',
  watch: {},
  data () {
    return {}
  },
  mounted () {

  },
  methods: {
    getStyleTemplate () {

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/2/Typography/setUp.vue